export const ActionTypes = {
    SET_USER: "SET_USER",
    SET_COUNTRY_LIST:"SET_COUNTRY_LIST",
    SET_ACTIVE_TAB:"SET_ACTIVE_TAB",
    SET_LANGUAGES_LIST:"SET_LANGUAGES_LIST",
    
    SET_PROGRAM_DETAILS: "SET_PROGRAM_DETAILS",
    SET_USER_TEMPLATE :"SET_USER_TEMPLATE",
    SET_LOADER : "SET_LOADER",
    SET_EDIT_FLAG : "SET_EDIT_FLAG",
    RESET_STORE : "RESET_STORE"

}